import { render, staticRenderFns } from "./beneficiary-mobile-phone-popover.vue?vue&type=template&id=b8a5e140&"
import script from "./beneficiary-mobile-phone-popover.vue?vue&type=script&lang=js&"
export * from "./beneficiary-mobile-phone-popover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports